import React, { ReactNode, useEffect, useState } from 'react';
import styles from './PlanHero.module.scss';
import plan1GigImageD from '../../images/plan-1gig-d.jpg';
import plan2GigImageD from '../../images/plan-2gig-d.jpg';
import plan5GigImageD from '../../images/plan-5gig-d.jpg';
import plan1GigImageHero from '../../images/plan-1gig-hero.jpg';
import plan2GigImageHero from '../../images/plan-2gig-hero.jpg';
import plan5GigImageHero from '../../images/plan-5gig-hero.jpg';
import { ROUTES } from '../../lib/constants';
import { Button } from '../Button/Button';
import { PlanType } from '../../lib/types';
import { Image } from '../Image/Image';

export const PlanHero = (props: {
  type: PlanType,
  children?: ReactNode;

}): React.JSX.Element => {
  const [image, setImage] = useState<string>();
  const [imageHero, setImageHero] = useState<string>();
  const [imageDesc, setImageDesc] = useState<string>();
  /* const [packageUrl, setPackageUrl] = useState<string>(); */

  useEffect(() => {
    if (props.type === '1 Gig') {
      setImage(plan1GigImageD);
      setImageHero(plan1GigImageHero);
      setImageDesc('Mother with small child looking at laptop.');
      /* setPackageUrl(ROUTES.connectAndControl.path); */
    } else if (props.type === '2 Gigs') {
      setImage(plan2GigImageD);
      setImageHero(plan2GigImageHero);
      setImageDesc('Man with headphones looking at laptop while puppy is standing on desk.');
      /* setPackageUrl(ROUTES.workHardPlayHard.path); */
    } else if (props.type === '5 Gigs') {
      setImage(plan5GigImageD);
      setImageHero(plan5GigImageHero);
      setImageDesc('Senior couple sitting by swimmimg pool. Man looking at laptop. Woman looking at phone.');
      /* setPackageUrl(ROUTES.everythingAndEverywhere.path); */
    }
  }, [ props.type ])

  return (
    <section className={`${styles.hero} ${styles['hero__' +props.type.replace(' ', '').toLowerCase()]}`}>
      <div className={styles.waves}>
        <div className={styles.designElement}></div>
      </div>

      <div className={`grid-12 ${styles.container}`}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className='headline__h2'>
              { props.type === '1 Gig' && 'Connect & Control' }
              { props.type === '2 Gigs' && 'Work Hard, Play Hard' }
              { props.type === '5 Gigs' && 'Everything & Everywhere' }
            </h1>

            <div className={styles.imageWrap}>
              <Image
                sources={[
                  { src: image, breakpoint: 'default'}, 
                  { src: imageHero, breakpoint: '960px'}
                ]}
                alt={imageDesc}
                loading="eager"
              />
            </div>

          </div>

          <div>
            <div className={styles.priceWrap}>
              <p className='headline__h2'>
                { props.type }
              </p>
              <p className='headline__h2'> 
                { props.type === '1 Gig' && '$80' }
                { props.type === '2 Gigs' && '$95' }
                { props.type === '5 Gigs' && '$195' }
                <span> / month</span>
              </p>
            </div>

            <div className={styles.body}>
              { props.children }
            </div>

            <div className={styles.footer}>
              <Button
                className={styles.packageBtn}
                path={ROUTES.checkAvailability.path}  
                target='_self'
                size='lg'
                gradient={ props.type === '2 Gigs' ? 'orange' : undefined }
    
              >
                Select Package
              </Button>
              
              <Button 
                className={styles.compareBtn}
                seconday={true}
                path={ROUTES.gigInternet.path}
                target='_self'
                size='lg'
              >
                Compare Packages
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>
  )

}